export default __webpack_public_path__ + "static/bg-advice-6d5b0583ca4da530bb7f6e1458053113.png";